import * as React from 'react';
import { useState } from 'react';
import { parse } from 'qs';

import t from './locales';
import { IYadoOrderItem, IYadoRoom, ICartItems, IResort } from './types';
import { CURRENT_CART_VERSION } from './constants';
import { retrieveCartItems, storeCartItems } from './helpers';
import Button from '../Shared/Button';


const ORDER_FORM_SELECTOR = '#order_form';

// Fake API integration for new.
const syncCart = () => {
  return new Promise<void>((resolve) => {
    setTimeout(() => { resolve(); }, 1000);
  });
};

function isValid(yadoOrderItem: IYadoOrderItem, totalAdultNum: number): boolean {
  const adultsInCart: number = yadoOrderItem.rooms.reduce((count: number, currentRoom: IYadoRoom): number => (
    count + (currentRoom.males + currentRoom.females)
  ), 0);
  return totalAdultNum === adultsInCart;
}

interface IProps {
  yadoName: string;
  totalAdultNum: number;
  resort: IResort;
}

// NOTE: jQuery required
// 宿予約は現在jQueryに依存しているコードなので例外的に使用する

const YadoCartButton: React.FC<IProps> = ({ yadoName, totalAdultNum, resort }) => {

  const [isLoading, toggleLoading] = useState(false);
  const url = new URL(window.location.href);

  async function handleClick(event: MouseEvent) {
    event.preventDefault();
    if (isLoading) { return; }
    const query: any = parse((window as any).jQuery(ORDER_FORM_SELECTOR).serialize());
    const { yado_id, plan_id, room_type, checkin_date, checkout_date, checkin_time, total_amount_including_tax, rooms } = query;
    const yadoOrderItem: IYadoOrderItem = {
      yadoName,
      yadoId: yado_id,
      roomType: room_type,
      planId: plan_id,
      resort,
      checkInDate: checkin_date,
      checkOutDate: checkout_date,
      checkInTime: checkin_time[1], // DOMに2つ存在するのでセレクトボックスの値を取得
      totalAmountIncludingTax: Number(total_amount_including_tax),
      rooms: rooms.map((room: any) => ({
         males: Number(room.males),
         females: Number(room.females),
         childAges: (room.child_ages || []).map((age: any) => Number(age)),
      })),
    }
    if (!isValid(yadoOrderItem, totalAdultNum)) {
      alert(t.pleaseSelectNumberOfMalesAndFemales());
      return;
    }
    toggleLoading(true);
    await syncCart();
    const cartItems: ICartItems = retrieveCartItems(CURRENT_CART_VERSION);
    storeCartItems({
      ...cartItems,
      yadoOrderItems: [...cartItems.yadoOrderItems, yadoOrderItem],
    });
    toggleLoading(false);
  }

  return (
    // snow-cart-button = gtmのカートインイベント用のクラス
    // TODO: クラス以外の方法でトリガーする
    <Button href="#" onClick={handleClick} isLoading={isLoading} className="snow-cart-button">
      {t.addToCart()}
    </Button>
  );
}

export default YadoCartButton;
